import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ProviderStatusPipe'
})
export class ProviderStatusPipe implements PipeTransform {

  private listObj = {
    0: 'Pending',
    1: 'Activated',
    2: 'Deactivated',
    3: 'Rejected',
  };

  transform(value: number): string {
    console.log("transforming: ", value)
    return this.listObj.hasOwnProperty(value) ? this.listObj[value] : '';
  }

}
